export const ordersIt: Record<string, string> = {
  // Orders
  'your_orders': 'I Tuoi Ordini',
  'unpaid_invoice': 'fattura non pagata',
  'unpaid_invoices': 'fatture non pagate',
  'orders_total': 'totale ordini',
  'order_total': 'totale ordine',
  'start_dress_journey': 'Inizia il Viaggio del Tuo Abito',
  'no_orders_message': 'Non hai ancora ordini. Prenota un appuntamento per iniziare la tua esperienza abito personalizzato.',
  'order_details': 'Dettagli Ordine',
  'total_amount': 'Importo Totale',
  'deposit': 'Acconto',
  'discount': 'Sconto',
  'percentage_discount': 'Sconto Percentuale',
  'fixed_discount': 'Sconto Fisso',
  'financial_summary': 'Riepilogo Finanziario',
  'payment_status': 'Stato Pagamento',
  'deposit_required': 'Acconto Richiesto',
  'total_paid': 'Totale Pagato',
  'outstanding_balance': 'Saldo Rimanente',
  'invoices_created': 'Fatture Emesse',
  'manage_payments': 'Gestisci Pagamenti',
  'important_dates': 'Date Importanti',
  'expected_ready_date': 'Data Prevista di Completamento',
  'second_fitting': 'Seconda Prova',
  'delivery_date': 'Data di Consegna',
  'order_timeline': 'Timeline Ordine',
  'invoices': 'Fatture',
  'pay_now': 'Paga Ora',
  'paid': 'Pagato',
  'partial': 'Parziale',
  'invoice_status_draft': 'Bozza',
  'invoice_status_issued': 'Emessa',
  'invoice_status_paid': 'Pagata',
  'payment_request_status_pending': 'In Attesa',
  'payment_request_status_sent': 'Inviata',
  'payment_request_status_paid': 'Pagata',
  'payment_request_status_overdue': 'Scaduta',
  'payment_method_cash': 'Contanti',
  'payment_method_card': 'Carta',
  'payment_method_bank_transfer': 'Bonifico Bancario',
  'payment_method_other': 'Altro',

  // Status labels (uppercase)
  'deposit_paid_caps': 'ACCONTO PAGATO',
  'invoices_caps': 'FATTURE',
  'cash_caps': 'CONTANTI',
  'order_placed_caps': 'ORDINE EFFETTUATO',
  'deposit_received_caps': 'ACCONTO RICEVUTO',
  'no_completed_orders_found_caps': 'NESSUN ORDINE COMPLETATO TROVATO',
  'pending_caps': 'IN ATTESA',
  'paid_caps': 'PAGATO',
  'unpaid_caps': 'NON PAGATO',
  'draft_caps': 'BOZZA',
  'open_caps': 'APERTO',
  'confirmed_caps': 'CONFERMATO',
  'in_progress_caps': 'IN CORSO',
  'completed_caps': 'COMPLETATO',
  'cancelled_caps': 'ANNULLATO',
  'archived_caps': 'ARCHIVIATO',
  'ready_caps': 'PRONTO',
  'production_caps': 'PRODUZIONE',
  'new_caps': 'NUOVO',
  'contacted_caps': 'CONTATTATO',
  'qualified_caps': 'QUALIFICATO',
  'proposal_sent_caps': 'PROPOSTA INVIATA',
  'won_caps': 'VINTO',
  'lost_caps': 'PERSO',
  'active_caps': 'ATTIVO',
  'overdue_caps': 'SCADUTO',
  'due_caps': 'SCADENZA',

  // Orders page specific
  'manage_dress_orders': 'Gestisci ordini abiti e traccia i progressi',
  'order_management': 'Gestione Ordini',
  'search_orders_placeholder': 'Cerca per numero ordine, cliente o nome prodotto...',
  'filter_by_status': 'Filtra per stato',
  'all_statuses': 'Tutti gli Stati',
  'draft': 'Bozza',
  'open': 'Aperto',
  'confirmed': 'Confermato',
  'cancelled': 'Annullato',
  'archived': 'Archiviato',
  'order_number': 'Ordine #',
  'customer': 'Cliente',
  'balance_due': 'Saldo Dovuto',
  'due_date': 'Data Scadenza',
  'status': 'Stato',
  'unknown_customer': 'Cliente Sconosciuto',
  'no_products': 'Nessun prodotto',
  'unknown_product': 'Prodotto Sconosciuto',
  'no_orders_found_criteria': 'Nessun ordine trovato che corrisponde ai tuoi criteri',
  'no_orders_created_yet': 'Nessun ordine creato ancora',
  'order_deleted_successfully': 'Ordine eliminato con successo',
  'failed_to_delete_order': "Impossibile eliminare l'ordine",
  'failed_to_fetch_orders': 'Impossibile recuperare gli ordini',
  'orders.customer.loadOrdersError': 'Impossibile caricare gli ordini. Riprova.',
  'orders.customer.loadOrderDetailsError': "Impossibile caricare i dettagli dell'ordine. Riprova.",
  'orders.customer.createPaymentError': 'Impossibile creare il pagamento. Riprova.',
  'confirm_delete_order': 'Sei sicura di voler eliminare questo ordine?',
  'archive': 'Archivia',
  'back_to': 'Torna a',
  'no_items': 'Nessun articolo',
  'overdue': 'Scaduto',
  'order_archived_successfully': 'Ordine archiviato con successo',
  'failed_to_archive_order': "Impossibile archiviare l'ordine",
  'save_changes': 'Salva modifiche',
  'payment_overview': 'Panoramica pagamenti',

  // Order details
  'order': 'Ordine',
  'production': 'Produzione',
  'ready': 'Pronto',
  'total_amount_colon': 'Importo Totale:',
  'deposit_colon': 'Acconto:',
  'expected_ready_date_colon': 'Data Prevista di Completamento:',
  'due': 'Scadenza',
  'unpaid': 'Non Pagato',
  'pay_soon': 'Paga (Presto)',
  'deposit_paid': 'Acconto Pagato',
  'no_completed_orders_found': 'Nessun ordine completato trovato',
  'customer_information': 'Informazioni Cliente',
  'name_colon': 'Nome:',
  'email_colon': 'Email:',
  'phone_colon': 'Telefono:',
  'internal_notes': 'Note Interne',
  'alteration_tasks': 'Attività di Modifica',
  'no_alteration_tasks_found': 'Nessuna attività di modifica trovata',
  'order_created': 'Ordine Creato',
  'order_updated_event': 'Ordine Aggiornato',
  'invoice_created_event': 'Fattura Creata',
  'payment_received_event': 'Pagamento Ricevuto',
  'payment_request_created_event': 'Richiesta di Pagamento Creata',
  'task_created_event': 'Attività Creata',
  'task_completed_event': 'Attività Completata',
  'no_timeline_events': 'Nessun evento trovato',
  'status_updated': 'Stato ordine aggiornato con successo',
  'failed_update_status': "Impossibile aggiornare lo stato dell'ordine",
  'task_status_updated': 'Stato attività aggiornato con successo',
  'failed_update_task_status': "Impossibile aggiornare lo stato dell'attività",
  'delivery_date_colon': 'Data di Consegna:',
  'payment_history': 'Storico Pagamenti',
  'no_payments_yet': 'Nessun pagamento ancora',
  'completed_status': 'Completato',
  'first_fitting_colon': 'Prima Prova:',
  'second_fitting_colon': 'Seconda Prova:',
  'due_date_colon': 'Data di Scadenza:',
  'payment_successful': 'Pagamento Riuscito',
  'payment_processed_successfully': 'Pagamento elaborato con successo',

  // Orders filters & sorting
  'orders.filters.title': 'Filtri',
  'orders.filters.createdDate': 'Data Creazione',
  'orders.filters.dueDate': 'Data Scadenza',
  'orders.filters.dateRange': 'Intervallo Date',
  'orders.filters.orderTotal': 'Totale Ordine',
  'orders.filters.outstandingBalance': 'Saldo Residuo',
  'orders.filters.amount': 'Importo',
  'orders.filters.from': 'Da',
  'orders.filters.to': 'A',
  'orders.filters.min': 'Min',
  'orders.filters.max': 'Max',
  'orders.filters.hasUnpaidBalance': 'Solo con saldo non pagato',
  'orders.filters.clearAll': 'Cancella Tutto',
  'orders.filters.apply': 'Applica Filtri',
  'orders.filters.category': 'Categoria',
  'orders.filters.product': 'Prodotto',
  'orders.filters.hasUnrequestedAmount': 'Ha importo non richiesto',
  'orders.filters.includeArchived': 'Includi ordini archiviati',
  'orders.sort.recentlyCreated': 'Creati di Recente',
  'orders.sort.oldestFirst': 'Più Vecchi',
  'orders.sort.amountHighLow': 'Importo: Alto-Basso',
  'orders.sort.amountLowHigh': 'Importo: Basso-Alto',
  'orders.sort.dueDateSoonest': 'Scadenza: Più Vicina',
  'orders.sort.orderNumber': 'Numero Ordine',
  'orders.empty.noResults': 'Nessun ordine trovato con i filtri selezionati',
  'orders.empty.noOrders': 'Nessun ordine ancora',
  'orders.empty.noOrdersDesc': 'Crea il tuo primo ordine per iniziare.',
  'orders.empty.clearFilters': 'Cancella Filtri',
  'orders.pagination.showing': 'Mostrando {from}-{to} di {total} ordini',
  'orders.stats.totalOrders': 'Ordini Totali',
  'orders.stats.totalAmount': 'Importo Totale',
  'orders.stats.active': 'Attivi',
  'orders.stats.unpaidBalance': 'Saldo Non Pagato',
  'orders.stats.unrequestedAmount': 'Non Richiesto',
  'orders.stats.overdue': 'Scaduti',
  'orders.stats.show': 'Mostra statistiche',
  'orders.stats.hide': 'Nascondi statistiche',
  'orders.columns.toggle': 'Colonne',
  'orders.table.order': 'Ordine',
  'orders.table.items': 'Articoli',
  'orders.table.amount': 'Importo',
  'orders.table.itemCount': '{count} articoli',
  'orders.table.itemSingle': '1 articolo',
  'orders.table.noItems': 'Nessun articolo',
  'orders.table.balanceDue': 'saldo dovuto',
  'orders.table.paid': 'Pagato',
  'orders.table.dueSoon': 'Scade presto',
  'orders.table.overdueLabel': 'Scaduto',
  'orders.table.unrequested': 'Non Richiesto',
  'orders.table.fullyRequested': 'Completamente Richiesto',
  'orders.table.toRequest': 'da richiedere',
  'orders.subtitle': '{count} ordini',

  // Order Create Dialog
  'orders.create.title': 'Crea Nuovo Ordine',
  'orders.create.description': 'Crea un nuovo ordine abito per una cliente con misure',
  'orders.create.tabs.productsCustomer': 'Prodotti e Cliente',
  'orders.create.tabs.measurementsDetails': 'Misure e Dettagli',
  'orders.create.customer': 'Cliente *',
  'orders.create.selectCustomer': 'Seleziona una cliente',
  'orders.create.products': 'Prodotti *',
  'orders.create.addProduct': 'Aggiungi Prodotto',
  'orders.create.noProducts': 'Nessun prodotto aggiunto',
  'orders.create.noProductsHint': 'Clicca "Aggiungi Prodotto" per iniziare',
  'orders.create.product': 'Prodotto',
  'orders.create.selectProduct': 'Seleziona prodotto',
  'orders.create.quantity': 'Quantità',
  'orders.create.price': 'Prezzo',
  'orders.create.discount': 'Sconto (Opzionale)',
  'orders.create.discountAmount': 'Importo €',
  'orders.create.discountPercent': 'Percentuale %',
  'orders.create.discountExceedsSubtotal': 'Lo sconto non può superare il subtotale',
  'orders.create.subtotal': 'Subtotale:',
  'orders.create.discountLabel': 'Sconto ({details}):',
  'orders.create.totalAmount': 'Totale:',
  'orders.create.measurementSet': 'Set di Misure *',
  'orders.create.selectMeasurementSet': 'Seleziona set di misure',
  'orders.create.noMeasurements': 'Nessuna misura trovata per questa cliente. Aggiungi prima le misure.',
  'orders.create.deposit': 'Importo Acconto (€)',
  'orders.create.dueDate': 'Data Scadenza *',
  'orders.create.notes': 'Note Interne',
  'orders.create.notesPlaceholder': 'Aggiungi note interne su questo ordine...',
  'orders.create.next': 'Avanti: Misure e Dettagli',
  'orders.create.back': 'Indietro',
  'orders.create.creating': 'Creazione...',
  'orders.create.createOrder': 'Crea Ordine',
  'orders.create.success': 'Ordine creato con successo',
  'orders.create.error': "Impossibile creare l'ordine",
  'orders.create.version': 'Versione',
  'orders.create.searchCustomer': 'Cerca per nome o email...',
  'orders.create.noCustomerFound': 'Nessun cliente trovato.',
  'orders.create.orderDate': 'Data Ordine',
  'orders.create.orderDateHint': 'Lascia vuoto per la data odierna',
  'orders.create.setCustomOrderDate': 'Imposta data ordine personalizzata',
  'orders.create.searchProducts': 'Cerca per nome, SKU o marca...',
  'orders.create.allCategories': 'Tutti',
  'orders.create.noProductsFound': 'Nessun prodotto trovato',
  'orders.create.changeProduct': 'Cambia',

  // Orders page actions
  'orders.deleteTitle': 'Elimina Ordine',
  'orders.deleteConfirmation': 'Sei sicuro di voler eliminare questo ordine?',
  'orders.deleteWarning': "L'ordine verrà eliminato e potrà essere ripristinato solo contattando il supporto.",
  'orders.actions.deleteOrder': 'Elimina Ordine',
};
